module.exports = __webpack_public_path__ + "img/download.8859e17b.svg";